import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    // No minimum height: the card lives in a fixed one-screen grid, and a minimum here scrolls the card and
    // clips its bottom edge - where the failure type legend, the only key to the segment colours, is drawn.
    chartWrapper: {
        height: "100%",
        width: "100%",
    },
    loadingWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
    },
}));
